module.exports = __webpack_public_path__ + "static/iphone4.c07a4666.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/iphone4.png
// module id = 532
// module chunks = 195485404593854